/* Culture-Kings style product cards.
   1. Size chips on hover - reads each product's variants from Shopify's
      /products/<handle>.js endpoint the first time a card is hovered.
   2. Tags sold-out badges so CSS can colour them differently from Sale badges.
      card-product.liquid renders both as a bare <span class="badge"> with no
      distinguishing class, so the only way to tell them apart is the text.
   3. Corrects the image `sizes` attribute on grid cards (see fixImageSizes). */
(function () {
  var cache = {};

  // ---- 3. sharper grid images -------------------------------------------
  // Dawn builds the <img sizes> from settings.page_width, assuming a 1200px
  // container at 4 columns, so it advertises a ~267px slot. This collection
  // grid is full width at up to 5 columns, where cards are 370-500px wide.
  // The browser was therefore picking the 360w file for a 500px slot and the
  // photos looked soft. Re-declaring sizes makes srcset pick a sharp candidate.
  // Proper long-term fix is editing the two `sizes` attributes in
  // snippets/card-product.liquid; this avoids rewriting that 33KB file.
  var CARD_SIZES = '(min-width: 1400px) 22vw, (min-width: 990px) 26vw, (min-width: 750px) 34vw, 50vw';

  function fixImageSizes(root) {
    (root || document).querySelectorAll('.card-wrapper .card__media img').forEach(function (img) {
      if (img.dataset.ckSized) return;
      img.dataset.ckSized = '1';
      if (img.getAttribute('srcset')) img.setAttribute('sizes', CARD_SIZES);
    });
  }

  function sizeOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var raw = opts[i];
      var name = (raw && raw.name ? raw.name : raw) || '';
      if (String(name).toLowerCase().indexOf('size') > -1) return i;
    }
    return -1;
  }

  function build(card, product) {
    var idx = sizeOptionIndex(product);
    if (idx < 0) return;

    var inner = card.querySelector('.card__inner') || card.querySelector('.card__media');
    if (!inner || inner.querySelector('.ck-sizes')) return;

    var seen = {};
    var wrap = document.createElement('div');
    wrap.className = 'ck-sizes';

    (product.variants || []).forEach(function (v) {
      var val = v['option' + (idx + 1)];
      if (!val || seen[val]) return;
      seen[val] = true;

      var a = document.createElement('a');
      a.className = 'ck-size' + (v.available ? '' : ' ck-size--out');
      a.textContent = val;
      a.href = product.url + '?variant=' + v.id;
      a.setAttribute('aria-label', product.title + ' - size ' + val + (v.available ? '' : ' (sold out)'));
      wrap.appendChild(a);
    });

    if (wrap.children.length > 1) inner.appendChild(wrap);
  }

  function load(card) {
    if (card.dataset.ckDone) return;
    card.dataset.ckDone = '1';

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    var url = link.getAttribute('href').split('?')[0];
    if (cache[url]) { build(card, cache[url]); return; }

    fetch(url + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) { cache[url] = p; build(card, p); } })
      .catch(function () { /* leave the card as-is */ });
  }

  // Sale and Sold out badges are identical in markup - separate them by text
  // so Sale can be brand red and Sold out stays dark.
  function tagBadges(root) {
    (root || document).querySelectorAll('.card-wrapper .card__badge .badge').forEach(function (b) {
      var t = (b.textContent || '').trim().toLowerCase();
      if (t.indexOf('sold') > -1) b.classList.add('ck-badge--soldout');
      else b.classList.add('ck-badge--sale');
    });
  }

  function init(root) {
    fixImageSizes(root);
    (root || document).querySelectorAll('.card-wrapper.product-card-wrapper').forEach(function (card) {
      card.addEventListener('mouseenter', function () { load(card); }, { once: true });
      card.addEventListener('touchstart', function () { load(card); }, { once: true, passive: true });
    });
    tagBadges(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { init(); });
  var target = document.getElementById('ProductGridContainer');
  if (target && window.MutationObserver) {
    new MutationObserver(function () { init(target); }).observe(target, { childList: true, subtree: true });
  }
})();
